const contact = {
    title: 'Kontakt',
    submit: 'Prześlij',
}

export default contact
